module.exports = __webpack_public_path__ + "img/01d@2x.255a951b.svg";